<template>
    <div>
        <p class="login-label">手机号</p>
        <div class="login-phone-group">
            <span class="phone">
                <input type="number" class="form-item-base login-input disable_num_arrow" v-model.trim="mobile"
                    :class="{'login-input--hasval': mobile && String(mobile).length > 0}"
                    oninput="if(this.value.length > 11) this.value=this.value.slice(0, 11)"
                    placeholder="请输入手机号"/>
            </span>
            <span class="getcode u-ml16" id='act'>
                <a href="javascript:;" class="form-item-base login-getcode-btn"
                    :class="{'login-getcode-btn--disabled': isRequesting || isStartLeftTime || isInvalidMobile}"
                    >
                    <span v-if="isStartLeftTime">{{leftSeconds}}秒后重发</span>
                    <span v-else-if="isEverGotCode">重新获取</span>
                    <span v-else>获取验证码</span>
                </a>
            </span>
        </div>
        <div id='captcha'></div>
        <p class="login-label u-mt16">验证码</p>
        <input type="text" v-model.trim="verifyCode"
            class="form-item-base login-input"
            :class="{'login-input--hasval': verifyCode}"
            @keydown.enter="doLogin"
            maxlength="8" placeholder="请输入验证码"/>


        <!-- 统一显示错误消息 -->
        <p class="login-errmsg-container" v-if="validateMag && validateCode != MOBILE_PWD_FAIL_TOOMANY_TIMES">
            <span class="login-errmsg">{{validateMag}}</span>
        </p>

        <a href="javascript:;" class="form-item-base login-btn u-mt16"
            :class="{'login-btn--active': !disableLoginBtn}"
            @click="doLogin">
            <span v-if="isSubmitting">登录中...</span>
            <span v-else>登录</span>
        </a>

        <!-- 图形验证码 -->
        <div class="login-pop-container" v-if="isShowCaptchaPop">
            <div class="login-pop">
                <header class="pop-title">
                    验证码
                    <a href="javascript:;" class="pop-close" @click="isShowCaptchaPop = false">×</a>
                </header>
                <div class="pop-content">
                    <captcha :mobile="mobile" :type="type" @on-submit-captcha="onSubmitCaptcha"></captcha>
                </div>
            </div>
        </div>
    </div>
</template>≤

<script>
    import axios from 'axios'
    import Captcha from './Captcha.vue'
    import ErrorCodeMixin from '../mixin/ErrorCodeMixin.vue'
    import UtilMixin from '../mixin/UtilMixin.vue'
    import url from '@lianjia/helper/url';
    export default {
        components: { Captcha },
        mixins: [ErrorCodeMixin, UtilMixin],
        props: ['type', 'ljCode', 'password'],
        data: function() {
            return {
                mobile: null,
                verifyCode: '',
                verifyKey: '',

                validateCode: 0, //验证错误类型
                validateMag:'',

                isShowCaptchaPop: false,
                leftSeconds: 59,
                isRequesting: false,
                isSubmitting: false,
                isStartLeftTime: false,
                isEverGotCode: false        //判断是否已经获取过验证, 用于显示按钮文案"重新获取"
            }
        },
        computed: {
            disableLoginBtn: function() {
                return this.isInvalidMobile ||
                        !this.verifyCode ||
                        this.isSubmitting
            },
            isInvalidMobile: function() {
                return !this.mobile || this.mobile.length < 11
            }
        },
        mounted: function () {
          this.loadCaptcha();
        },
        methods: {
            loadCaptcha: function(){
                url.loadjs(`https://s1.ljcdn.com/captcha-js-sdk-v2/captcha.js`,() => {
                    this.captcha = new CaptchaSDK.Captcha({
                    endpoint: window.location.hostname === 'zlogin.ke.com' ? 'https://captcha.lianjia.com': 'http://test3-captcha.lianjia.com',
                    scene: 'bkjjxy_h5',
                    renderTo: '#captcha',
                    timeout: 10000,
                    onTokenChange: function(token) {
                        console.log('onTokenChange', token);
                    },
                    onValidateComplete: (result) => {
                        console.log('onValidateComplete', result);
                        if(result) {
                            this.getVerifyCode();
                        }
                    },
                    onError: function(err) {
                        console.log("onError", err);
                    },
                    geetest:{
                        product: "bind",
                        bindTo: "#act",
                    }
                    });
                    this.captcha.init();
                });
            },
            getVerifyCode: function() {
                if(this.isRequesting || this.isStartLeftTime || this.isInvalidMobile) return;

                this.isRequesting = true;

                //调用获取验证码接口
                let params = {
                    mobile: this.mobile,
                    app: meta.app
                }
                axios.post('/api/login/verifyCode', this.stringify(params)).then(({data}) => {
                    this.verifyKey = data.key
                    this._startLeftTime()
                    this.isRequesting = false;
                }).catch(({ response }) => {  //获取验证码异常, 可以点击重新获取
                    this._setErrorInfo(response)

                    //获取短信验证码过多, 显示输入验证码弹层
                    if(this.validateCode == this.MOBILE_PWD_FAIL_TOOMANY_TIMES) {
                        this.isShowCaptchaPop = true
                    }

                    this.isRequesting = false;
                });
            },
            onSubmitCaptcha: function(verifyKey) {       //成功提交图形验证码
                this.verifyKey = verifyKey
                this.isShowCaptchaPop = false
                this._startLeftTime()
                this._clearError()
            },
            doLogin: function() {
                if(this.disableLoginBtn) return

                this.isSubmitting = true

                //请求登录验证接口: 登录成功跳转到成功页， 失败提示消息
                let url = '/api/login/mobileVerifyCode'
                let params;
                let codeValue = ''; // 微信公众号登录需要的code  
                if (window.location.search.indexOf('code') > -1) {
                   codeValue = window.location.split('code=')[1];
                } 
                params = {
                        mobile: this.mobile,
                        verifyCode: this.verifyCode,
                        verifyKey: this.verifyKey,
                        site: meta.site,
                        wechatCode: codeValue || ''
                }
                if(this.type === 'bind') {       //需绑定手机
                    params.ljCode = this.ljCode
                    params.password = this.password
                    url = '/ljCodeBindMobile'
                }

                axios.post(url, this.stringify(params)).then( (response) => {
                    this.isSubmitting = false
                    if(response.data.code == 0){   //验证成功， 发送成功消息
                        this.$emit('on-success', response.data)
                    } else {
                        this._setErrorInfo(response)
                    }
                }).catch(({ response }) => {
                    this.isSubmitting = false
                    this._setErrorInfo(response)
                });
            },
            _startLeftTime: function() {
                this.isEverGotCode = true
                this.isStartLeftTime = true
                this.leftSeconds = 59
                let intv = setInterval( () => {
                    if(this.leftSeconds > 1) {
                        this.leftSeconds--;
                    } else {
                        this.isStartLeftTime = false
                        clearInterval(intv);
                    }
                }, 1000);
            },
            _setErrorInfo: function(response) {
                this.validateCode = response.data.code;
                this.validateMag = response.data.message;

                if(response.status ===  500) {
                    this.validateMag = '服务器异常'
                }
            },
            _clearError: function() {
                this.validateCode = 0;
                this.validateMag = '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// MobileLogin.vue?53808c24